import { useMemo } from 'react'
import { DEFAULT_VIEW_STATE } from '../lib/mapConfig'

export function useMapBoundsAndZoom(
  locations: Array<{ latitude?: number | null; longitude?: number | null }>
) {
  const initialViewState = useMemo(() => {
    const locs = locations.filter(w => w.latitude != null && w.longitude != null)
    if (!locs.length) return DEFAULT_VIEW_STATE
    const lngs = locs.map(w => w.longitude!)
    const lats = locs.map(w => w.latitude!)
    const minLng = Math.min(...lngs), maxLng = Math.max(...lngs)
    const minLat = Math.min(...lats), maxLat = Math.max(...lats)
    const centerLng = (minLng + maxLng) / 2
    const centerLat = (minLat + maxLat) / 2
    const span = Math.max(maxLng - minLng, maxLat - minLat)
    let zoom = 14
    if (span > 10) zoom = 5
    else if (span > 5) zoom = 6
    else if (span > 2) zoom = 7
    else if (span > 1) zoom = 8
    else if (span > 0.5) zoom = 9
    else if (span > 0.1) zoom = 10
    else if (span > 0.01) zoom = 12
    return { longitude: centerLng, latitude: centerLat, zoom }
  }, [locations])

  return { initialViewState }
}
